import { Stack, Theme } from '@mui/material';
import { FC } from 'react';
import Icon from '../icon';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

interface Props {
  /** May be async; redundant new-chat streak is handled in the parent via `local-settings.service`. */
  onClick: () => void | Promise<void>;
  hideLabel?: boolean;
  className?: string;
}

const useStyles = createUseStyles<string, { width: number }>((theme: Theme) => ({
  newChatButton: {
    boxSizing: 'border-box',
    '&.hide-label': {
      justifyContent: 'center',
    },
    '& .MuiAvatar-root': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
    },
  },
  iconHoverSpin: {
    '&:hover': {
      transform: 'rotate(90deg)',
    },
    transition: 'transform 0.2s ease',
    transform: 'rotate(0deg)',
  },
}));

const NewChatButton: FC<Props> = ({ onClick, hideLabel, className }) => {
  const styles = useStyles();
  const compClass = classNames(styles.newChatButton, className, { 'hide-label': hideLabel });

  const handleClick = () => {
    void onClick();
  };

  return (
    <Stack gap={1} width="100%" direction="row" justifyContent="center" className={compClass}>
      <Icon
        name="plus"
        background="first"
        color="black"
        className={styles.iconHoverSpin}
        onClick={handleClick}
      />
    </Stack>
  );
};

export default NewChatButton;
